import React from 'react';

export default (func, fallback = (<div />)) => {
    return React.lazy(func);
}
